import React, { useState } from "react";
import navimage from "../../../images/Group 1000001625.svg";
import product from "../../../images/Vector.svg";
import addaproduct from "../../../images/add-product (1) 1.svg";
import overview1 from "../../../images/element-3.svg";
import bank from "../../../images/balance.svg";
import logout from "../../../images/logout.svg";
import order from "../../../images/note.svg";
import email from "../../../images/Email(2).svg";
import overviewgrey from "../../../images/overview.svg";
import image from "../../../images/gallery.svg"
import "./sidebar.scss";

import emailonstara from "../../../images/emailonstara.png";
import Overview from "./Components/Overview";
import { logoutAction } from "../../redux/slices/userSlices";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Orders from "./Components/Orders";
import HelpLine from "./Components/HelpLine";
import AddProduct from "./Components/AddProduct";
import Products from "./Components/Products";
import BankAccount from "./Components/BankAccount";
import SellerNavigationComponent from "./Components/SellerNavigationComponent";

const EcomSellerDashboard = () => {
  const [activeSection, setActiveSection] = useState("");
  const [overview, setOverview] = useState(false);
  const [products, setProduct] = useState(false);
  const [productlist, setProductlist] = useState(false);
  const [orders, setOrders] = useState(false);
  const [helplines, setHelpline] = useState(false);
  const [account, setAccount] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const [active, setActive] = useState("overview");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleClickEditProfile = () => {
    setOverview(true);
    setProduct(false);
    setAccount(false);
    setOrders(false);
    setProductlist(false);
    setHelpline(false);
    setActiveLink("overview");
  };
  const handleClickHelpline = () => {
    setOverview(false);
    setProduct(false);
    setAccount(false);
    setOrders(false);
    setProductlist(false);
    setHelpline(true);
    setActiveLink("helpline");
  };

  const handleClickManageaddress = () => {
    setOverview(false);
    setProduct(true);
    setProductlist(false);
    setAccount(false);
    setActiveLink("addproduct");
  };
  const handleClickproduct = () => {
    setOverview(false);
    setProduct(false);
    setProductlist(true);
    setOrders(false);
    setAccount(false);
    setActiveLink("product");
  };
  const handleClickOrders=()=>{
    setOverview(false);
    setProduct(false);
    setProductlist(false);
    setOrders(true);
    setHelpline(false);
    setAccount(false);
    setActiveLink("orders"); 
  }
  
  const handleClickBankaccount=()=>{
    setOverview(false);
    setProduct(false);
    setOrders(false);
    setAccount(true);
    setHelpline(false);
    setActiveLink("addbankaccount"); 
  }

  // const [activeSection, setActiveSection] = useState('');

  // const handleClickProducts = () => {
  //   setActiveSection('products');
  // };

  return (
    <div style={{ display: "flex" }}>
      {/* <div
        className="sidebarimagediv"
        // onClick={handleClickEditProfile}
      >
        <img src={navimage} className="onstarasellersidebarimage" />
        <p className="sidemenutext">Menu</p>
        <div>
          {active === "overview" ? (
            <div
              className={`sidemenuoverview active`}
              onClick={handleClickEditProfile}
            >
              <div style={{ display: "flex" }}>
                <img src={overview1} className="overviewimage" />
                <p className="sidemenuoverviewtext">Overview</p>
              </div>
            </div>
          ) : (
            <div
              className={`sidemenuoverview`}
              onClick={handleClickEditProfile}
            >
              <div style={{ display: "flex" }}>
                <img src={overviewgrey} className="overviewimage" />
                <p className="sidemenuoverviewgreytext">Overview</p>
              </div>
            </div>
          )}
        </div>
        <div style={{ display: "flex" }}>
        <div
            style={{ display: "flex" }}
            className={`sidemenuproductlist ${
              activeSection === "product" ? "active" : ""
            }`}
          >
          <img src={product} className="sidemenuproductimage" />
          <p className="sidemenuproductstext" onClick={handleClickproduct}>Products</p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            style={{ display: "flex" }}
            className={`sidemenuaddproduct ${
              activeSection === "addproduct" ? "active" : ""
            }`}
          >
            <img src={addaproduct} className="sidemenuaddproductimage" />
            <p className="addproductstext" onClick={handleClickManageaddress}>
              Add Products
            </p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}  className={`sidemenuhelpline ${
              activeSection === "helpline" ? "active" : ""
            }`}>
          <img src={email} className="sidemenuvariationimage" />
          <p className="variationstext" onClick={handleClickHelpline}>HelpLine</p>
        </div>
        </div>
        <div style={{ display: "flex" }}>
          <img src={order} 
           className={`sidemenuvariationimage ${
            activeSection === "orders" ? "active" : ""
          }`} />
          <p className="orderstext" onClick={handleClickOrders}>Orders</p>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ display: "flex" }}  className={`sidemenuaddbankaccount ${
              activeSection === "addbankaccount" ? "active" : ""
            }`}>
          <img src={bank} className="sidemenubankimage" />
          <p className="bankaccountstext"  onClick={handleClickBankaccount}>Bank Accounts</p>

          </div>
        </div>
          <div style={{display:"flex"}}>
            <img src={emailonstara} className="emailonstara"/>
            <div>
            <p className="facingtrouble">Facing Trouble?</p>
<p className="onstaraemailid">Support@onstara.com</p>
            </div>
          </div>
        <p className="sidebarprofiletext">Profile</p>
        <div
          style={{ display: "flex" }}
          onClick={() => {
            dispatch(logoutAction());
            navigate("/");
          }}
        >
          <img src={logout} className="sidemenulogoutimage" />
          <p className="sidebarlogouttext">Logout</p>
        </div>
      </div> */}
<SellerNavigationComponent/>
{/* <Overview/> */}


      {/* {overview ? <Overview/> : null} */}
      {/* {products ? <AddProduct /> : null}
      {productlist? <Products/> : null}
      {account?<BankAccount/>:null}
      {orders? <Orders/> : null}
      {helplines?<HelpLine/> : null}
      {!orders && !helplines && !products && !productlist&& !account && !overview ? <Overview /> : null} */}
    </div>
  );
};

export default EcomSellerDashboard;
